import React from 'react';
import { useGrid } from '../provider';
import Cell from './cell';
const Column = (props) => {
    const { doc, columnId } = props;
    const { filteredTagsColumn } = useGrid();
    return (React.createElement("div", { className: 'column' }, filteredTagsColumn.map((value, index) => {
        const rowIndex = index + 1;
        const cellId = `${columnId}-${rowIndex}`;
        return React.createElement(Cell, { key: `cell-${cellId}`, cellId: cellId, rowIndex: rowIndex, doc: doc, classification: value });
    })));
};
export default Column;
